// The text a before or after value copies as. Null when there's nothing to copy.
export const auditValueText = (value: unknown) => {
  if (value === null || value === undefined || value === "") return null
  if (typeof value === "string") return value
  return JSON.stringify(value, null, 2)
}
